import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { validationSchema, initialValues } from "../../componentes/CrearCuenta";
import "../../scss/index.scss";
import imaLogo from "../../imagenes/logo.png";
import { ENTORNO, HabilitarGoogleRecaptcha } from "../../utils/constantes";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import CssBaseline from "@mui/material/CssBaseline";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Fab from "@mui/material/Fab";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Fade from "@mui/material/Fade";
import IconButton from "@mui/material/IconButton";
import CheckIcon from "@mui/icons-material/Check";
import {
  Grid,
  Header,
  Image,
  Form,
  Segment,
  Modal,
  Menu,
} from "semantic-ui-react";
import {
  crear_cuenta_de_pasajero,
  nombre,
  apellido,
  email,
  telefono,
  contrasena,
  repetir_contrasena,
  aceptar_las_condiciones_del_servicio,
  crear_cuenta,
  politica_de_privacidad,
  condiciones_del_servicio,
  cerrar,
  ya_se_ha_registrado_un_usuario_con_este_email,
} from "../../utils/traductor";
import { apiTexto } from "../../api/texto";
import { apiUsuario } from "../../api/usuario";
import Swal from "sweetalert2";
import { BarraSuperior } from "../../estilos/barraSuperior";
import { estiloBotones } from "../../estilos";
import { estiloColores } from "../../estilos/colores";
import { estiloSegmento } from "../../estilos";
import {
  setActivarCuenta_PrimeraVezQueIngresa,
  setemail,
} from "../../utils/variablesLocales";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { TextField } from "@mui/material";
import Button from "@mui/material/Button";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputAdornment from "@mui/material/InputAdornment";
import { apigoogleRecaptchaV3 } from "../../api";
import ReactRecaptcha3 from "react-google-recaptcha3";

//////////////////////////////////////////////////////////

const apigooglerecaptchav3 = HabilitarGoogleRecaptcha
  ? new apigoogleRecaptchaV3()
  : null;
const apiusuario = new apiUsuario();
const apitexto = new apiTexto();

function exampleReducerPP(state, action) {
  switch (action.type) {
    case "OPEN_MODAL":
      return { openPP: true, dimmerPP: action.dimmer };
    case "CLOSE_MODAL":
      return { openPP: false };
    default:
      throw new Error();
  }
}

function exampleReducerCS(state, action) {
  switch (action.type) {
    case "OPEN_MODAL":
      return { openCS: true, dimmerCS: action.dimmer };
    case "CLOSE_MODAL":
      return { openCS: false };
    default:
      throw new Error();
  }
}

function ScrollTop(props) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      "#back-to-top-anchor"
    );

    if (anchor) {
      anchor.scrollIntoView({
        block: "center",
      });
    }
  };

  return (
    <Fade in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{ position: "fixed", bottom: 16, right: 16 }}
      >
        {children}
      </Box>
    </Fade>
  );
}

ScrollTop.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

const ValidarTokenRecaptcha = async (
  tokenGoogleRecaptchaV3,
  ipPublicaValor,
  nombre,
  apellido,
  email,
  telefono,
  password,
  navigateToActivarCuenta
) => {
  const respuestaVerificacionRecaptcha = await apigooglerecaptchav3.verificar(
    tokenGoogleRecaptchaV3,
    ipPublicaValor
  );

  if (respuestaVerificacionRecaptcha === true) {
    IngresarConfirmar(
      nombre,
      apellido,
      email,
      telefono,
      password,
      navigateToActivarCuenta
    );
  } else {
  }
};

const IngresarConfirmar = async (
  nombre,
  apellido,
  email,
  telefono,
  password,
  navigateToActivarCuenta
) => {
  email = email.toLowerCase();

  const validarEmail = await apiusuario.validarEmail(email);

  if (validarEmail === "Ok") {
    Swal.fire({
      title: "Error!",
      text: ya_se_ha_registrado_un_usuario_con_este_email,
      icon: "error",
      confirmButtonText: "Ok",
      confirmButtonColor: estiloColores.Gris,
    });
  } else {
    const response = await apiusuario.crearCuenta(
      nombre,
      apellido,
      email,
      telefono,
      password
    );

    setemail(email);
    setActivarCuenta_PrimeraVezQueIngresa("1");

    Swal.fire({
      title: "",
      text: response.Mensaje,
      icon: "success",
      confirmButtonText: "Ok",
      confirmButtonColor: estiloColores.Azul,
    }).then(function () {
      //destruir el recaptcha
      if (HabilitarGoogleRecaptcha) ReactRecaptcha3.destroy();

      navigateToActivarCuenta();
    });
  }
};

export function CrearCuenta(props) {
  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const [showPassword1, setShowPassword1] = React.useState(false);
  const handleClickShowPassword1 = () => setShowPassword1((show) => !show);
  const handleMouseDownPassword1 = (event) => {
    event.preventDefault();
  };

  const [statePP, dispatchPP] = React.useReducer(exampleReducerPP, {
    open: false,
    dimmer: undefined,
  });
  const { openPP, dimmerPP } = statePP;

  const [stateCS, dispatchCS] = React.useReducer(exampleReducerCS, {
    open: false,
    dimmer: undefined,
  });
  const { openCS, dimmerCS } = stateCS;

  const navigate = useNavigate();

  const navigateToActivarCuenta = () => {
    navigate(ENTORNO.URL_APLICACION + "/ActivarCuenta");
  };

  const navigateToInicio = () => {
    navigate(ENTORNO.URL_APLICACION + "/Ingresar");
  };

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        //validacion google recaptcha v3
        //1. calculo ip publica
        const ipPublica = require("react-public-ip");
        const ipPublicaValor = (await ipPublica.v4()) || "";

        //2. obtengo token
        if (HabilitarGoogleRecaptcha) {
          ReactRecaptcha3.getToken().then(
            (tokenGoogleRecaptchaV3) => {
              ValidarTokenRecaptcha(
                tokenGoogleRecaptchaV3,
                ipPublicaValor,
                formik.values.nombre,
                formik.values.apellido,
                formik.values.email,
                formik.values.telefono,
                formik.values.password,
                navigateToActivarCuenta
              );
            },
            (error) => {
              console.log(error);
            }
          );
        } else {
          IngresarConfirmar(
            formik.values.nombre,
            formik.values.apellido,
            formik.values.email,
            formik.values.telefono,
            formik.values.password,
            navigateToActivarCuenta
          );
        }
      } catch (error) {
        Swal.fire({
          title: "Error!",
          text: error.Mensaje,
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: estiloColores.Gris,
        });
      }
    },
  });

  ////////////////////////////////

  const [PoliticaPrivacidad, setPoliticaPrivacidad] = useState(null);
  const [CondicionesDeUso, setCondicionesDeUso] = useState(null);

  useEffect(() => {
    if (HabilitarGoogleRecaptcha) {
      ReactRecaptcha3.init(ENTORNO.GOOGLE_RECAPTCHA_V3_SITEKEY).then(
        (status) => {}
      );
    }
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const responsePoliticaPrivacidad = await apitexto.obtener(
          "Politica de privacidad"
        );

        if (responsePoliticaPrivacidad.length !== 0) {
          setPoliticaPrivacidad(responsePoliticaPrivacidad[0].Texto);
        }

        const responseCondicionesDeUso = await apitexto.obtener(
          "Condiciones de uso"
        );

        if (responseCondicionesDeUso.length !== 0) {
          setCondicionesDeUso(responseCondicionesDeUso[0].Texto);
        }
      } catch (error) {
        console.error(error);
      }
    })();

    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div style={{ overfxlow: "hidden", touchAction: "none" }}>
      <form onSubmit={formik.handleSubmit}>
        <React.Fragment>
          <CssBaseline />
          <AppBar style={{ background: "#DC030E" }}>
            <Toolbar>
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                onClick={navigateToInicio}
                aria-label="menu"
                sx={{ mr: 2 }}
              >
                <ArrowBackIcon fontSize="medium" />
              </IconButton>
              <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                {crear_cuenta}
              </Typography>
              <IconButton
                size="large"
                aria-label="display more actions"
                edge="end"
                color="inherit"
                type="submit"
              >
                <CheckIcon />
              </IconButton>
            </Toolbar>
          </AppBar>
          <Toolbar id="back-to-top-anchor" />
          <Container>
            <Segment style={estiloSegmento.Pasajero}>
              <Grid textalign="center" container style={{ padding: "1em 0em" }}>
                <Grid.Row>
                  <div className="ingresar">
                    <Grid.Column style={{ width: "75%" }}>
                      <Image
                        src={imaLogo}
                        className="logoCrearCuenta"
                        centered
                      />
                      <Header as="h3">{crear_cuenta_de_pasajero}</Header>
                      {/* <form
                        size="large"
                        textalign="center"
                        onSubmit={formik.handleSubmit}
                      > */}
                      <Box
                        // component="form"
                        sx={{
                          "& > :not(style)": { m: 0.2, width: "100%" },
                        }}
                        noValidate
                        autoComplete="off"
                      >
                        <TextField
                          id="nombre"
                          label={nombre}
                          placeholder={nombre}
                          variant="standard"
                          name="nombre"
                          type="text"
                          value={formik.values.nombre}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.nombre &&
                            Boolean(formik.errors.nombre)
                          }
                          helperText={
                            formik.touched.nombre && formik.errors.nombre
                          }
                        />
                        <TextField
                          id="apellido"
                          label={apellido}
                          placeholder={apellido}
                          variant="standard"
                          name="apellido"
                          type="text"
                          value={formik.values.apellido}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.apellido &&
                            Boolean(formik.errors.apellido)
                          }
                          helperText={
                            formik.touched.apellido && formik.errors.apellido
                          }
                        />
                        <TextField
                          id="email"
                          label={email}
                          placeholder={email}
                          variant="standard"
                          name="email"
                          type="text"
                          value={formik.values.email}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.email && Boolean(formik.errors.email)
                          }
                          helperText={
                            formik.touched.email && formik.errors.email
                          }
                        />
                        <TextField
                          id="telefono"
                          label={telefono}
                          placeholder={telefono}
                          variant="standard"
                          name="telefono"
                          type="text"
                          value={formik.values.telefono}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.telefono &&
                            Boolean(formik.errors.telefono)
                          }
                          helperText={
                            formik.touched.telefono && formik.errors.telefono
                          }
                        />
                        <TextField
                          id="password"
                          label={contrasena}
                          placeholder={contrasena}
                          variant="standard"
                          name="password"
                          type={showPassword ? "text" : "password"}
                          value={formik.values.password}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.password &&
                            Boolean(formik.errors.password)
                          }
                          helperText={
                            formik.touched.password && formik.errors.password
                          }
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                >
                                  {showPassword ? (
                                    <VisibilityOff />
                                  ) : (
                                    <Visibility />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />

                        <TextField
                          id="passwordRepetir"
                          label={repetir_contrasena}
                          placeholder={repetir_contrasena}
                          variant="standard"
                          name="passwordRepetir"
                          type={showPassword1 ? "text" : "password"}
                          value={formik.values.passwordRepetir}
                          onChange={formik.handleChange}
                          error={
                            formik.errors.passwordRepetir &&
                            Boolean(formik.errors.passwordRepetir)
                          }
                          helperText={
                            formik.touched.passwordRepetir &&
                            formik.errors.passwordRepetir
                          }
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword1}
                                  onMouseDown={handleMouseDownPassword1}
                                >
                                  {showPassword1 ? (
                                    <VisibilityOff />
                                  ) : (
                                    <Visibility />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Box>
                      <br></br>
                      <Form.Checkbox
                        name="aceptoCondiciones"
                        label={aceptar_las_condiciones_del_servicio}
                        onChange={(_, data) =>
                          formik.setFieldValue(
                            "aceptoCondiciones",
                            data.checked
                          )
                        }
                        checked={formik.values.aceptoCondiciones}
                        error={formik.errors.aceptoCondiciones}
                      />
                      <br></br>
                      <label onClick={() => dispatchPP({ type: "OPEN_MODAL" })}>
                        {politica_de_privacidad}
                      </label>
                      <br></br>
                      <label onClick={() => dispatchCS({ type: "OPEN_MODAL" })}>
                        {condiciones_del_servicio}
                      </label>
                    </Grid.Column>
                  </div>
                </Grid.Row>
              </Grid>
              <Modal
                dimmer={dimmerPP}
                open={openPP}
                onClose={() => dispatchPP({ type: "CLOSE_MODAL" })}
              >
                <Menu style={BarraSuperior.Modal}>
                  <Menu.Item>
                    <h2 style={{ color: "white" }}>{politica_de_privacidad}</h2>
                  </Menu.Item>
                </Menu>
                <Modal.Content>
                  <div className="divTextos">{PoliticaPrivacidad}</div>
                </Modal.Content>
                <Modal.Actions style={{ margin: "0px 0px 13px 0px" }}>
                  <Button
                    style={estiloBotones.Cerrar}
                    onClick={() => dispatchPP({ type: "CLOSE_MODAL" })}
                  >
                    {cerrar}
                  </Button>
                </Modal.Actions>
              </Modal>
              <Modal
                dimmer={dimmerCS}
                open={openCS}
                onClose={() => dispatchCS({ type: "CLOSE_MODAL" })}
              >
                <Menu style={BarraSuperior.Modal}>
                  <Menu.Item>
                    <h2 style={{ color: "white" }}>
                      {condiciones_del_servicio}
                    </h2>
                  </Menu.Item>
                </Menu>
                <Modal.Content>
                  <div className="divTextos">{CondicionesDeUso}</div>
                </Modal.Content>
                <Modal.Actions style={{ margin: "0px 0px 13px 0px" }}>
                  <Button
                    style={estiloBotones.Cerrar}
                    onClick={() => dispatchCS({ type: "CLOSE_MODAL" })}
                  >
                    {cerrar}
                  </Button>
                </Modal.Actions>
              </Modal>
            </Segment>
          </Container>
          <ScrollTop {...props}>
            <Fab size="small" aria-label="scroll back to top">
              <KeyboardArrowUpIcon />
            </Fab>
          </ScrollTop>
        </React.Fragment>
      </form>
    </div>
  );
}
